import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://syvopcycbplnllddmrin.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN5dm9wY3ljYnBsbmxsZGRtcmluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU1MzA1MTQsImV4cCI6MjA3MTEwNjUxNH0.XsRhHi55jQ3yAnelpyjhEJaDMYIi-iiKeymNluZkLFg'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
